The response from the `updateWebhookSubscriptionSigningConfiguration` mutation.
